import getFilePickerViewTypeValue from './utils/getFilePickerViewTypeValue';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { FilePickerViewType } from 'owa-filepicker';

export default {
    AFPChangePreferredViewType: {
        name: 'AFPChangePreferredViewType',
        customData: (_: OwaUserConfiguration, viewType: FilePickerViewType) => [
            getFilePickerViewTypeValue(viewType),
        ],
    },
    AFPSetUserPreferredAction: {
        name: 'AFPSetUserPrefferdAction',
        customData: (_: OwaUserConfiguration, action: number) => [action],
    },
    AFPSetUserPreferredActionGroups: {
        name: 'AFPSetUserPreferredActionGroups',
        customData: (_: OwaUserConfiguration, action: number) => [action],
    },
};
